import React from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import './language_selector.css'

const LanguageSelector = ({ className }) => {
    const { i18n } = useTranslation(); // i18n instance to interact with the language settings

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language); // Change the language when button is clicked
    };

    return (
        <div className={`language-switcher ${className || ''}`}>
            <div className="language-switcher__country" onClick={() => handleChangeLanguage('en')}>
                <img src={`${process.env.PUBLIC_URL}/country_icons/gb.svg`} alt=""></img>
            </div>

            <div className="language-switcher__country" onClick={() => handleChangeLanguage('es')}>
                <img src={`${process.env.PUBLIC_URL}/country_icons/es.svg`} alt=""></img>
            </div>

        </div>
    );
};

export default LanguageSelector;
